import { PathOptions } from "leaflet";

export const cgh_base_existente = (feature: any): PathOptions => {
  return {
    color: "#20B2AA",
    weight: 2,
    opacity: 1,
    fillColor: "#48D1CC",
    fillOpacity: 0.6,
  };
};
